<template>
	<div>
		<!--弹出框-->
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" style="height: 100%;">
			<el-dialog :title="titmc" :modal="false" :visible.sync="dialogVisible" v-dialogDrag :before-close="handleClose" :close-on-click-modal="false" :show-close="true" :close-on-press-escape="false">
				<el-row>
					<el-col :span="12">
						<el-form-item type="type" label="演练名称" prop="ylmc">
							<el-input type="type" class="from-el-input" placeholder="演练名称" v-model.trim="ruleForm.ylmc" :disabled="states=='ck'"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item type="type" label="演练分类" prop="ylfl">
							<el-select v-model.trim="ruleForm.ylfl" placeholder="请选择演练分类" class="from-el-input" :disabled="states=='ck'">
								<el-option v-for="item in ylList" :key="item.id" :label="item.name" :value="item.code"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<!-- 预案名称 -->
				<el-row>
					<el-col :span="12">
						<treepop @obj="objdata_bm" @close="treeClose_bm" :label="label_bm" :datalist="bumenList" :currentdata="currentDatabm"></treepop>
					</el-col>
          <el-col :span="12">
          	<el-form-item type="type" label="演练地点" prop="yldd">
          		<el-input type="type" class="from-el-input" placeholder="演练地点" v-model.trim="ruleForm.yldd" :disabled="states=='ck'"></el-input>
          	</el-form-item>
          </el-col>
				</el-row>
				<el-row>
					<el-col :span="12" style="position: relative">
						<treepop @obj="objdata_ld" @close="treeClose_ld" :label="label_ld" :datalist="fzrList" :currentdata="currentDatald"></treepop>
					</el-col>
          <el-col :span="12" style="position: relative">
          	<treepop @obj="objdata_ry" @close="treeClose_ry" :label="label_ry" :datalist="cyrylist" :currentdata="currentDatary"></treepop>
          </el-col>
				</el-row>
				<el-row>
          <el-col :span="12">
            <el-form-item type="type" label="开始时间" prop="starttime">
              <el-date-picker v-model.trim="ruleForm.starttime" @change="ksjsChange" class="from-el-input-item" :disabled="states=='ck'"
                value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="开始时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item type="type" label="结束时间" prop="endtime">
              <el-date-picker @change="jsjsChange" v-model.trim="ruleForm.endtime" class="from-el-input-item" :disabled="states=='ck'"
                value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item type="type" label="演练内容" prop="ylnr">
							<el-input type="textarea" :rows="3" class="from-el-input-text" placeholder="演练内容" v-model.trim="ruleForm.ylnr" :disabled="states=='ck'"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item type="type" label="综合评价" prop="zhpj">
							<el-input type="textarea" :rows="3" class="from-el-input-text" placeholder="综合评价" v-model.trim="ruleForm.zhpj" :disabled="states=='ck'"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<!-- 附件 -->
				<el-row v-if="states=='xz'||states=='bj'">
				  <el-col :span="24">
				    <div class="titna">
				      <span class="addSpan">附件</span>
				    </div>
				    <div class='fujian'>
				      <el-upload class="upload-demo" drag action="" multiple :on-remove="handleRemove" :on-change='changes'
				        :file-list="fileList" :limit="5" :auto-upload='false'>
				        <i class="el-icon-upload"></i>
				        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
				      </el-upload>
				      <div class='fujian fujians' v-if="filetabledata.length!=0">
				        <ul class="fjhxlist">
				          <li v-for="(item,i) in filetabledata" :key="i">
				            <div class="names" style="text-align: left;">{{item.sourceName}}</div>
				            <div class="names cz">
				              <el-button type="primary" icon="el-icon-download" circle @click="DownloadFile(i,item)" class="btnmargin"></el-button>
				              <el-button type="success" icon="el-icon-delete" v-if="states!='ck'" circle @click="deletesfile(i,item)"
				                class="btnmargin"></el-button>
				            </div>
				          </li>
				        </ul>
				      </div>
				    </div>
				  </el-col>
				</el-row>
				<el-row v-if="states=='ck' && filetabledata.length!=0">
				  <el-col :span="24">
				    <div class="titna">
				      <span class="addSpan">附件</span>
				    </div>
				    <div class='fujian'>
				      <ul class="fjhxlist">
				        <li v-if="filetabledata.length==0" style='width:100%;height:80px;line-height: 80px;color:#ccc'>暂无附件,请上传！</li>
				        <li v-for="(item,i) in filetabledata" :key="i" v-if="filetabledata.length!=0">
				          <div class="names" style="text-align: left;">{{item.sourceName}}</div>
				          <div class="names cz">
				            <el-button type="primary" icon="el-icon-download" circle @click="DownloadFile(i,item)" class="btnmargin"></el-button>
				            <el-button type="success" icon="el-icon-delete" v-if="states!='ck'" circle @click="deletesfile(i,item)"
				              class="btnmargin"></el-button>
				          </div>
				        </li>
				      </ul>
				    </div>
				  </el-col>
				</el-row>
				<!-- 图片 -->
				<el-row style="margin-top: 10px;">
					<el-col :span="24" class="col-class" v-if="states=='xz'||states=='bj' || ImgfileListData.length!=0">
						<div class="titna">
							<span class="addSpan">图片</span>
						</div>
						<div class="tp" v-if="states=='xz'||states=='bj'">
							<el-upload action :auto-upload="false" list-type="picture-card" :on-preview="imghandl" :on-change="imgchanges" :on-remove="imghandleRemove">
							</el-upload>
				      <div class='fujian fujians' v-if="ImgfileListData.length!=0">
				        <ul class="fjhxlist">
				          <li v-for="(item,i) in ImgfileListData" :key="i">
				            <div class="names" style="text-align: left;">{{item.sourceName}}</div>
				            <div class="names cz">
				              <el-button type="primary" icon="el-icon-download" circle @click="DownloadFile(i,item)" class="btnmargin"></el-button>
				              <el-button type="success" icon="el-icon-delete" v-if="states!='ck'" circle @click="deletesfile(i,item,'tp')"
				                class="btnmargin"></el-button>
				            </div>
				          </li>
				        </ul>
				      </div>
						</div>
						<div class="tp tps" v-if="states=='ck' && ImgfileListData.length!=0">
							<ul class="qrtpul">
								<li class v-for="(item,i) in ImgfileListData" :key="i">
									<img :src="item.url" alt style="width:20%; cursor: pointer; float: left;" @click="imgzoom(item.url)" />
								</li>
							</ul>
						</div>
					</el-col>
				</el-row>

				<span slot="footer" class="dialog-footer">
          <el-form-item>
            <el-button v-if="states !== 'ck'" @click="cancel()" type="warning">取 消</el-button>
            <el-button v-if="states == 'xz'" type="success" @click="xzdeteRmine('ruleForm','xz')">保 存</el-button>
            <el-button v-if="states == 'bj'" type="success" @click="xzdeteRmine('ruleForm','bj')">保 存</el-button>
          </el-form-item>
        </span>
			</el-dialog>
		</el-form>
		<!--弹出框-->
    <!-- 图片预览 -->
    <el-dialog :visible.sync="imgdialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
	</div>
</template>
<script>
  import { ydbjbxxQuery, yjylSave, yjylUpdate, dictioninfo, deleteFile, orglist, userlist } from "@/api/api";
  import treepop from '@/components/mangement/treepopup.vue';
  import axios from 'axios'
	export default {
    props: {
    	mystate: Array
    },
		data() {
			return {
        urlsss: '/userApi/minio/updateFileMulti/',
        downloadUrl: "/userApi/minio/downloadFile/",
				dialogVisible: true, // 弹出框显示,
				titmc: '应急演练详情',
				ruleForm: {
					ylmc: '',
					ylfl: '',
					ylbm: '',
          ylbmid: '',
					yldd: '',
					ylfzr: '',
          ylfzrid: '',
					cyry: '',
          cyryid: '',
					starttime: this.getNowTimes(),
          endtime: this.getNowTimes(),
					ylnr: '',
					zhpj: '',
          pictures: '',
          fujian: '',
				},
				rules: {
					ylmc: [
						{ required: true, message: '请输入必填项', trigger: 'blur' },
						{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
					],
					ylfl: [
						{ required: true, message: '请输入必填项', trigger: 'blur' }
					],
					ylbm: [
						{ required: true, message: '请输入必填项', trigger: 'blur' }
					],
					yldd: [
						{ required: true, message: '请输入必填项', trigger: 'blur' }
					],
          ylfzr: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' }
          ],
          cyry: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' }
          ],
          starttime: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' }
          ],
          endtime: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' }
          ],
					ylnr: [
						{ required: true, message: '请输入必填项', trigger: 'blur' },
						{ min: 1, max: 200, message: '长度在 1 到 50 个字符', trigger: 'blur' }
					],
					zhpj: [
						{ required: true, message: '请输入必填项', trigger: 'blur' },
						{ min: 1, max: 200, message: '长度在 1 到 50 个字符', trigger: 'blur' }
					],
				},
        ylList: [
          {name:'类型1', code: 0},
          {name:'类型2', code: 1},
        ],
				states: '',

        imgfileList: [],	// 图片
        ImgfileListData: [], // 修复前图片回显
        imgfileUrl: '',
        dialogImageUrl: '', // 图片上传用到
        imgdialogVisible: false,

        fileList: [], // 附件
        filetabledata: [], // 回显附件
        fileUrl: '',

				editDisable: false, // 是否可以编辑

        bumenList: [], //部门tree
        cyrylist: [], //参与人员tree
        fzrList: [], //负责人tree
        row: null,
        currentData: '',
        currentDatabm: '',
        currentDatary: '',
        currentDatald: '',

        label_bm: '演练部门',
        label_ry: '参与人员',
        label_ld: '演练负责人',
        current_bm: '',
			}
		},
    components: {
    	// 引入组件
      treepop
    },
		cerate() {
			// 初始化数据

		},
		methods: {
      objdata_bm(data) {
        let _this = this;
        this.fzrList = [];
        this.current_bm = data.name;
        this.ruleForm.ylbm = data.name;
        this.ruleForm.ylbmid = data.id;
        userlist({}).then((res) => {
          for (let i = 0; i < res.data.length; i++) {
            if (this.current_bm === res.data[i].deptName) {
              let mmm = res.data[i];
              mmm.name = res.data[i].username;
              _this.fzrList.push(mmm);
            }
          }
        });
      },
      treeClose_bm() {
      },
      objdata_ld(data) {
        this.cyrylist = [];
        this.ruleForm.ylfzr = data.name;
        this.ruleForm.ylfzrid = data.id;
        for (let i = 0; i < this.fzrList.length; i++) {
          if (data.name !== this.fzrList[i].name) {
            this.cyrylist.push(this.fzrList[i]);
          }
        }
      },
      treeClose_ld() {},
      objdata_ry(data) {
        this.ruleForm.cyry = data.name;
        this.ruleForm.cyryid = data.id;
      },
      treeClose_ry() {},

			// 函数
			handleClose(done) {
				this.dialogVisible = false;
        this.$emit("getcancel", { "dialogVisible": this.dialogVisible });
			},
			cancel() {
				// 取消
				this.dialogVisible = false;
        this.$emit("getcancel", { "dialogVisible": this.dialogVisible });
			},
			// 保存
			xzdeteRmine(formName, states) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let config = {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }; // 添加请求头
            //照片Url
            if (this.imgfileList.length != 0) {
              let formData = new FormData();
              this.imgfileList.forEach((el, index) => {
                formData.append('file', el); // 'file' 可变 相当于 input 表单的name 属性
              });
              axios.post(this.urlsss, formData, config).then(res => {
                if(res.data.code === 200) {
                  this.imgfileUrl = res.data.data;
                }
              }).catch(err => {});
            }
            //附件
            if (this.fileList.length != 0) {
              let formData1 = new FormData();
              this.fileList.forEach((el, index) => {
                formData1.append('file', el); // 'file' 可变 相当于 input 表单的name 属性
              });

              axios.post(this.urlsss, formData1, config).then(res => {
                if (res.data.code == 200) {
                  this.$notify({
                    title: "提示",
                    message: res.data.message,
                    type: "success",
                  });
                  this.fileUrl = res.data.data;
                } else {
                  this.$notify({
                    title: "提示",
                    message: res.data.message,
                    type: "warning",
                  });
                }
              }).catch(err => {});
            }

            let _this = this;
            setTimeout(function() {
              if (states == 'xz') {
                let params = {
                  ydbYlMc: _this.ruleForm.ylmc, //演练名称
                  ydbYlfl: _this.ruleForm.ylfl, //演练分类
                  ydbYldw: _this.ruleForm.ylbm, //演练单位
                  ydbYldwId: _this.ruleForm.ylbmid, //演练单位id
                  ydbYldd: _this.ruleForm.yldd, //演练地点
                  ydbYlfzr: _this.ruleForm.ylfzr, //演练负责人
                  ydbCyry: _this.ruleForm.cyry, //参与人员
                  ydbKssj: _this.ruleForm.starttime, //开始时间
                  ydbJssj: _this.ruleForm.endtime, //结束时间
                  ydbYlnr: _this.ruleForm.ylnr, //演练内容
                  ydbYlpj: _this.ruleForm.zhpj, //综合评价
                  // ydbYlpj: _this.imgfileUrl, //照片
                  // ydbShiPin: _this.fileUrl, //附件
                };
                yjylSave(params).then((res) => {
                  if (res.code === 200) {
                    _this.$notify({
                      title: "提示",
                      message: "提交成功",
                      type: "success"
                    });
                    _this.dialogVisible = false;
                    _this.$emit("adddata", {
                      dialogVisible: _this.dialogVisible
                    });
                  } else {
                    _this.$notify({
                      title: "提示",
                      message: res.message,
                      type: "warning"
                    });
                  }
                })
              } else {
                let params = {
                 ydbYlMc: _this.ruleForm.ylmc, //演练名称
                 ydbYlfl: _this.ruleForm.ylfl, //演练分类
                 ydbYldw: _this.ruleForm.ylbm, //演练单位
                 ydbYldwId: _this.ruleForm.ylbmid, //演练单位id
                 ydbYldd: _this.ruleForm.yldd, //演练地点
                 ydbYlfzr: _this.ruleForm.ylfzr, //演练负责人
                 ydbCyry: _this.ruleForm.cyry, //参与人员
                 ydbKssj: _this.ruleForm.starttime, //开始时间
                 ydbJssj: _this.ruleForm.endtime, //结束时间
                 ydbYlnr: _this.ruleForm.ylnr, //演练内容
                 ydbYlpj: _this.ruleForm.zhpj, //综合评价
                 // ydbYlpj: _this.imgfileUrl, //照片
                 // ydbShiPin: _this.fileUrl, //附件
                  id: _this.row.id
                };
                if (params.ydbTuPian === '') {
                  params.ydbTuPian = null;
                }
                if (params.ydbShiPin === '') {
                  params.ydbShiPin = null;
                }
                yjylUpdate(params).then((res) => {
                  if (res.code === 200) {
                    _this.$notify({
                      title: "提示",
                      message: "提交成功",
                      type: "success"
                    });
                    _this.dialogVisible = false;
                    _this.$emit("bjadddata", {
                      dialogVisible: _this.dialogVisible
                    });
                  } else {
                    _this.$notify({
                      title: "提示",
                      message: res.message,
                      type: "warning"
                    });
                  }
                })
              }
            }, 500)
          }
        });
			},

			DownloadFile(index, row) {
        window.open("/userApi/minio/downloadFile/" + row.fileName);
			},
			// 删除文件
			deletesfile(index, row, type) {
        let params = {id:row.id, fileName:row.fileName};
        deleteFile(params).then((res) => {
        	if(res.code == 200) {
        		this.$notify({
        			title: '',
        			message: res.message,
        			type: 'success'
        		});
        		this.filetabledata.splice(index, 1)
        	}
        })
      },
      handleRemove(file, fileList) {
      	// 删除文件
        for (let i = 0; i < this.fileList.length; i++) {
          if (file.name == this.fileList[i].name) {
            this.fileList.splice(this.fileList[i], 1);
          }
        }
      },
      changes(file, fileList) {
      	let num = 1024.0
      	if(Number((file.size / Math.pow(num, 2)).toFixed(2)) > 10) {
      		fileList.splice(fileList.length - 1, 1)
      		this.$message.error('选择文件大于10M，请重新选择！')
      	} else {
      		this.fileList.push(file.raw)
      	}
      },
      imgzoom(url) {
        window.open(url);
      },
      imghandl(file) {
        this.dialogImageUrl = file.url;
        this.imgdialogVisible = true;
      },
      imghandleRemove(file, fileList) {
      	// 删除文件
        for (let i = 0; i < this.imgfileList.length; i++) {
          if (file.name == this.imgfileList[i].name) {
            this.imgfileList.splice(this.imgfileList[i], 1);
          }
        }
      },
      imgchanges(file, fileList) {
      	let num = 1024.0
      	if(Number((file.size / Math.pow(num, 2)).toFixed(2)) > 10) {
      		fileList.splice(fileList.length - 1, 1)
      		this.$message.error('选择文件大于10M，请重新选择！')
      	} else {
      		this.imgfileList.push(file.raw)
      	}
      },
      ksjsChange() {
        if (new Date(this.ruleForm.endtime) <= new Date(this.ruleForm.starttime)) {
          this.$notify({
            title: '提示',
            message: '值班开始时间不能小于结束时间！',
            type: 'success'
          });
          this.ruleForm.endtime = '';
        }
      },
      jsjsChange() {
        if (new Date(this.ruleForm.endtime) <= new Date(this.ruleForm.starttime)) {
          this.$notify({
            title: '提示',
            message: '值班结束时间不能小于开始时间！',
            type: 'success'
          });
          this.ruleForm.endtime = '';
        }
      },
      getNowTimes() {
        var date = new Date();
        this.year = date.getFullYear();
        this.month = (date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);
        this.date = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        this.hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        this.minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        this.second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        this.milliSeconds = date.getMilliseconds();
        var currentTime = this.year + '-' + this.month + '-' + this.date + ' ' + this.hour + ':' + this.minute
        return currentTime
      },
		},
		mounted() {
      this.states = this.mystate[0];
      this.row = this.mystate[1];
      if (this.states == 'bj' || this.states == 'ck') {
        // this.currentData = this.mystate[1].ydbName; //淤地坝名称
        this.currentDatabm = this.mystate[1].ydbYldw; //演练单位
        this.currentDatald = this.mystate[1].ydbYlfzr; //演练负责人
        this.currentDatary = this.mystate[1].ydbCyry; //参与人员

        this.ruleForm.ylmc = this.mystate[1].ydbYlMc; //演练名称
        this.ruleForm.ylfl = this.mystate[1].ydbYlfl; //演练分类
        this.ruleForm.ylbm = this.mystate[1].ydbYldw; //演练单位
        this.ruleForm.ylbmid = this.mystate[1].ydbYldwId; //演练单位id
        this.ruleForm.yldd = this.mystate[1].ydbYldd; //演练地点
        this.ruleForm.ylfzr = this.mystate[1].ydbYlfzr; //演练负责人
        this.ruleForm.cyry = this.mystate[1].ydbCyry; //参与人员
        this.ruleForm.starttime = this.mystate[1].ydbKssj; //开始时间
        this.ruleForm.endtime = this.mystate[1].ydbJssj; //结束时间
        this.ruleForm.ylnr = this.mystate[1].ydbYlnr; //演练内容
        this.ruleForm.zhpj = this.mystate[1].ydbYlpj; //综合评价

        // ydbYlpj: _this.imgfileUrl, //照片
        // ydbShiPin: _this.fileUrl, //附件

        // this.filetabledata = this.mystate[1].ydbFuJian;

        // if (this.mystate[1].status === 0) {
        //   this.ruleForm.lszt = '已落实'; //状态
        // } else {
        //   this.ruleForm.lszt = '未落实'; //状态
        // }
      }

      orglist({}).then((res) => {
        this.bumenList = res.data;
      });
    }
	}
</script>

<style scoped>
  >>>.el-dialog__body {
  	height: 500px;
  	overflow: auto;
  }

  >>>.el-date-editor .el-range__icon {
    margin-bottom: 15px;
  }

  >>>.el-date-editor .el-range-separator {
    padding-bottom: 5px;
  }

  >>>.el-input--prefix .el-input__inner {
    padding-left: 30px;
  }

  .treebox {
    width: 100%;
    margin: 0;
  }

	.input-preview {
		color: #3564e1;
		width: 35px;
		margin-left: 10px;
		cursor: pointer;
	}

	.fujian {
		width: -webkit-calc(100% - 102px);
		width: -moz-calc(100% - 102px);
		width: calc(100% - 102px);
		/* width: 100%; */
		float: left;
		border: 1px solid #ccc;
		border-radius: 4px;
		padding: 10px;
		overflow: auto;
	}

	.rowTop {
		margin-top: 10px;
	}

	.qrtpul {
		width: 100%;
		/*margin-top: 10px;*/
	}

	.tp {
		width: 87.9%;
		/* margin-left: 13px; */
		overflow: auto;
		border: 1px dashed #ccc;
		border-radius: 4px;
		float: right;
		padding: 2px;
	}

	.qrtpul li {
		width: 50px;
		height: 50px;
		border-radius: 4px;
		border: 1px solid #ccc;
		float: left;
		margin-right: 5px;
		position: relative;
	}
</style>
